__turbopack_context__.v({
  "card-field": "Field-module-scss-module__18FohW__card-field",
  "card-item-icon-circle": "Field-module-scss-module__18FohW__card-item-icon-circle",
  "field-data": "Field-module-scss-module__18FohW__field-data",
  "field-data-label": "Field-module-scss-module__18FohW__field-data-label",
  "field-data-subvalue": "Field-module-scss-module__18FohW__field-data-subvalue",
  "field-data-value": "Field-module-scss-module__18FohW__field-data-value",
  "field-data-value-placeholder": "Field-module-scss-module__18FohW__field-data-value-placeholder",
  "field-icon": "Field-module-scss-module__18FohW__field-icon",
});
